var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"bold upper xs-f-small md-f-small lg-f-large max-at-tweak section-title"},[_vm._v(_vm._s(_vm.text)),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }